import React from 'react';
import { Popover, Whisper, WhisperProps } from 'rsuite5';

interface PopoverWrapperProps extends Pick<WhisperProps, 'placement' | 'trigger' | 'enterable'> {
  /**
   * 是否启用 Popover
   */
  enabled?: boolean;
  children: React.ReactElement;
  popover: {
    title?: React.ReactNode;
    content: React.ReactNode;
  };
}

/**
 * PopoverWrapper，包裹元素就可以拥有Popover功能
 */
export const PopoverWrapper = React.memo(
  ({
    enabled = true,
    enterable = false,
    placement = 'top',
    trigger = 'hover',
    children,
    popover: { title, content },
  }: PopoverWrapperProps) => {
    const speaker = <Popover title={title}>{content}</Popover>;
    return enabled ? (
      <Whisper placement={placement} trigger={trigger} speaker={speaker} enterable={enterable}>
        {children}
      </Whisper>
    ) : (
      children
    );
  }
);
